import React from 'react';
import BrandDetailStatisticSearch from '../BrandDetailStatisticSearch';
import BrandDetailStatisticChart from '../BrandDetailStatisticChart';
import { useBrandDetailStatistic } from '../../../../../hooks/brand/detail/useBrandDetailStatistic';
import './BrandDetailStatisticSection.scss';

const BrandDetailStatisticSection = ({ storeId, setData }) => {
  const { getBrandDetailStatistic, brandDetailStatisticInfo } = useBrandDetailStatistic(storeId);
  const { keyword, data } = brandDetailStatisticInfo;

  return (
    <div className="brand-detail-statistic-section">
      {/*검색란*/}
      <BrandDetailStatisticSearch
        storeId={storeId}
        keyword={keyword}
        setData={setData}
        getBrandDetailStatistic={getBrandDetailStatistic}
      />

      {/*통계 차트*/}
      <BrandDetailStatisticChart data={data} />
    </div>
  );
};

export default BrandDetailStatisticSection;
